import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useApp } from '@/context/AppContext';
import { PageHeader, Card } from '@/components/common';
import { AlertTriangle, FileText, Sparkles, CalendarClock, Bell } from 'lucide-react';

const typeIcon = { alert: AlertTriangle, doc: FileText, insight: Sparkles, calendar: CalendarClock };
const typeColor = { alert: 'text-rose-500 bg-rose-50', doc: 'text-violet-500 bg-violet-50', insight: 'text-cyan-500 bg-cyan-50', calendar: 'text-amber-500 bg-amber-50' };

const Notifications = () => {
  const { t, tx, data } = useApp();
  const [items, setItems] = useState(data.notifications);
  const markAll = () => setItems((n) => n.map((x) => ({ ...x, unread: false })));

  return (
    <div>
      <PageHeader
        title={t('notif.title')}
        subtitle={t('notif.subtitle')}
        actions={
          <button onClick={markAll} data-testid="notif-mark-all" className="h-10 px-4 rounded-lg border border-white/80 bg-white/[0.96] backdrop-blur-xl text-sm font-medium text-zinc-700 hover:bg-white transition-colors">
            {t('notif.markAll')}
          </button>
        }
      />
      {items.length === 0 ? (
        <Card className="p-12 flex flex-col items-center text-center">
          <Bell className="w-8 h-8 text-zinc-300 mb-2" />
          <p className="text-sm text-zinc-400">{t('notif.empty')}</p>
        </Card>
      ) : (
        <div className="space-y-2.5">
          {items.map((n, i) => {
            const Icon = typeIcon[n.type];
            return (
              <motion.div key={n.id} initial={{ opacity: 0, x: -8 }} animate={{ opacity: 1, x: 0 }} transition={{ delay: i * 0.05 }}>
                <Card className={`p-4 flex items-center gap-4 ${n.unread ? 'border-l-4 border-l-cyan-500' : ''}`} data-testid={`notif-${n.id}`}>
                  <div className={`w-10 h-10 rounded-lg flex items-center justify-center shrink-0 ${typeColor[n.type]}`}><Icon className="w-5 h-5" /></div>
                  <p className={`flex-1 text-sm ${n.unread ? 'font-medium text-zinc-800' : 'text-zinc-500'}`}>{tx(n.text)}</p>
                  <span className="text-xs text-zinc-400 shrink-0">{n.time}</span>
                  {n.unread && <span className="w-2 h-2 rounded-full bg-cyan-500 shrink-0" />}
                </Card>
              </motion.div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default Notifications;
